import { makeStyles } from "@material-ui/core";

export const QuickLookupStyle = makeStyles((theme) => ({
    card: {
        margin: '1rem 0',
        padding: '2rem ',
        paddingBottom: '5rem',
        height: '100%'
    },
    priceRow: {
        display: 'flex',
        alignItems: 'center',
        width: '100%'
    },
    priceIcon: {
        color: theme.palette.text.secondary,
        fontSize: '1.25rem',
        marginLeft: 'auto'
    },
    alert: {
        marginBottom: '1rem',
        border: `1px solid ${theme.palette.warning.main}`,
        borderRadius: '6px',
        fontWeight: 500,
        '& .MuiAlert-icon': {
            color: theme.palette.warning.dark,
        },
    }
}));